import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Agent, BankDetails, Organization, OrganizationClient, OrganizationToken, ServiceProvider, ServiceRequestResponseTypes, UserModel } from "src/app/web-api-client";
import { OrganizationalTypes } from "../../../../enums/organizational-types.enum";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { forkJoin, Subject } from "rxjs";
import { OrganizationTokenComponent } from "../../organization-token/organization-token.component";
import { ServiceRequestResponseTypeUtil } from "../../../../shared/utils/service-request-response.utils";

@Component({
  selector: 'app-org-edit',
  templateUrl: './org-edit.component.html',
  styleUrls: ['./org-edit.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class OrgEditComponent implements OnInit {


  public isVikEnabled: boolean = false;
  public isServiceProviderEnabled: boolean = false;
  public isEGovAutomationEnabled: boolean = false;
  public isMessageDetailsSyncEnabled: boolean = true;

  public onClose = new Subject<boolean>();
  public agents: Agent[] = [];
  public selectedAgent: number = 0;
  public providers: ServiceProvider[] = [];
  public selectedProvider: number = 0;

  public isLoaded = true;
  public organizations: Organization[] = [];
  public editOrg: Organization;
  public OrganizationTypes = OrganizationalTypes;
  public orgTypes = Object.keys(OrganizationalTypes).filter(
    key => !isNaN(Number(OrganizationalTypes[key]))
  );

  public responseTypes = Object.keys(ServiceRequestResponseTypes)
    .filter(key => !isNaN(Number(ServiceRequestResponseTypes[key])))
    .map(key => ({ name: key, value: ServiceRequestResponseTypes[key] }));

  Form: FormGroup;

  public isChildSelected: boolean = false;
  constructor(private fb: FormBuilder,public _cdr:ChangeDetectorRef, private readonly modalService: NgbModal,public activeModal: NgbActiveModal, public orgClient: OrganizationClient) { }

  ngOnInit(): void {

    this.isLoaded = false;
    forkJoin(this.orgClient.getProviders(), this.orgClient.getAgentss())
      .subscribe(([providers, agents]) => {
        this.agents = agents;
        this.providers = providers;
        this.selectedAgent = this.editOrg.agentId;
        this.selectedProvider = this.editOrg.serviceProviderId;
        this.isLoaded = true;
        this.initializeForm();
      })
  }

  initializeForm() {

    this.isChildSelected = this.editOrg.parentOrganizationId && this.editOrg.parentOrganizationId > 0;

    this.Form = this.fb.group({
      title: [this.editOrg.title, Validators.required],
      vat: [this.editOrg.vat, Validators.required],
      enableVik: [this.editOrg.enableVikModule, Validators.required],
      description: [this.editOrg.description, Validators.required],
      organizationalType: [this.editOrg.organizationalType, Validators.required],
      selectedProvider: [this.editOrg.serviceProviderId, Validators.required],
      selectedAgent: [this.editOrg.agentId, Validators.required],
      includePayment: [this.editOrg.includePaymentProcess, Validators.required],
      parentChildType: [this.isChildSelected ? 'child' : 'parent'],  // Set initial value based on the organization being edited
      parentOrg: [this.editOrg.parentOrganizationId || null],  // Set initial value if the organization is a child and has a parent
      enableService: [this.editOrg.enableServiceProvider, Validators.required],
      enableEGovAutomation: [this.editOrg.enableEGovAutomation, Validators.required],
      responseType: [0]
    });

    this.isServiceProviderEnabled = this.editOrg.enableServiceProvider;
    this.isVikEnabled = this.editOrg.enableVikModule;
    this.isEGovAutomationEnabled = this.editOrg.enableEGovAutomation;
    this.isMessageDetailsSyncEnabled = this.editOrg.enableMessageDetailsSync ?? true;
    this._cdr.detectChanges();
  }

  onOrgTypeChange(type: string) {
    if (type === 'child') {
      this.isChildSelected = true;
    } else {
      this.isChildSelected = false;
      this.Form.controls['parentChildType'].setValue(null);  // Reset the parent organization value
    }

    this._cdr.detectChanges();
  }


  onSubmit() {
    if (this.Form.valid) {

      //url ?: string;



      this.editOrg.avatar = ' ';
      this.editOrg.url=' ';
      this.editOrg.title = this.Form.value.title;
      this.editOrg.vat = this.Form.value.vat;
      this.editOrg.description = this.Form.value.description;
      this.editOrg.organizationalType = +this.Form.value.organizationalType;
      this.editOrg.includePaymentProcess = this.Form.value.includePayment;
      this.editOrg.agentId = this.Form.value.selectedAgent;
      this.editOrg.serviceProviderId = this.Form.value.selectedProvider;
      this.editOrg.parentOrganizationId = this.Form.value.parentOrg;
      this.editOrg.enableServiceProvider = this.isServiceProviderEnabled;
      this.editOrg.enableVikModule = this.isVikEnabled;
      this.editOrg.enableEGovAutomation = this.isEGovAutomationEnabled;
      this.editOrg.enableMessageDetailsSync = this.isMessageDetailsSyncEnabled;
      this.editOrg.notificationType = +this.Form.value.responseType;


      this.orgClient.update(this.editOrg).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }


  onSelect(orgType: OrganizationalTypes): boolean {

    return orgType == this.editOrg.organizationalType;
  }

  getValue(orgType: OrganizationalTypes): number {
    return +orgType;
  }

  onBankAccountSelected(bankAccount: BankDetails) {
    this.editOrg.idBankDetails = bankAccount.idBankDetails;
    this._cdr.detectChanges();
  }

  onTokenShow() {
    let modalRef = this.modalService.open(OrganizationTokenComponent, { size: 'xl', centered: true, backdrop: 'static' });
    modalRef.componentInstance.orgId = this.editOrg.id;
    this._cdr.detectChanges();
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }



  onCheckboxChange() {

    this.isServiceProviderEnabled = !this.isServiceProviderEnabled;
    this._cdr.detectChanges();
  }

  public GetCyrilicRequestType(requestType: ServiceRequestResponseTypes): string {

    return ServiceRequestResponseTypeUtil.getCyrilicLabel(requestType);
  }
}
